import { Nullable } from '~types/common';
import { getSalaryRate } from '~utils/company/company';

/**
 * 반올림 없이 순수하게 소수점을 고정하는 함수
 *
 * (Number.toFixed 함수에서 반올림 한후 소수점을 고정함)
 *
 * @link https://labeebklatif.medium.com/js-number-tofixed-without-rounding-4da4207ba146
 * @param number
 * @param precision
 * @returns
 */
export function toFixedWithoutRound(number: number, precision = 1) {
  const sign = Math.sign(number);
  const factor = Math.pow(10, precision);

  return (Math.floor(Math.abs(number) * factor) / factor) * sign;
}

export function millionFormattedtoString(value: number | string) {
  return formattedMoney(Math.round(Number(value) / 10000));
}

export function millionFormattedDeletedComma(value: number) {
  return millionFormattedtoString(value).replace(',', '');
}

export function formattedMoney(value: number | string) {
  return Math.floor(Number(value)).toLocaleString();
}

export function deleteComma(value: string) {
  if (typeof value !== 'string') {
    return value;
  }

  return String(value).replace(/\,/g, '');
}

export function formattedDeletedComma(value: string) {
  return Number(deleteComma(value));
}
export function getNumberWithRange(value: Nullable<number>, low: number, high: number) {
  if (value === null) return null;
  if (value < low) return low;
  if (value > high) return high;

  return value;
}

export const parseToPercent = (demicalNumber: number, roundDemicalPoint: number = 1) => {
  if (!demicalNumber) return 0;
  const percent = demicalNumber * 100;

  return Number(percent.toFixed(roundDemicalPoint));
};

export function numberToKorean(num: number, type: 'total' | 'salary' | 'person') {
  function salesDisplayData(sales: number, unit: number) {
    const koreanNumber = (sales / unit).toFixed(1);

    return koreanNumber[koreanNumber.length - 1] === '0' || unit === 1.0e4
      ? koreanNumber.split('.')[0]
      : koreanNumber;
  }
  if (type === 'salary') {
    return getSalaryRate(num) + '%';
  }

  if (num >= 1.0e15) {
    return salesDisplayData(num, 1.0e15) + '경원';
  } else if (num >= 1.0e12) {
    return salesDisplayData(num, 1.0e12) + '조원';
  } else if (num >= 1.0e8) {
    return salesDisplayData(num, 1.0e8) + '억원';
  } else {
    return salesDisplayData(num, 1.0e4) + '만원';
  }
}
